//
// Module for common Tax Excluded And Free Step in Benefit Setup wizards
//
rs.module("participant/benefit/setup/common/wizard/taxexcludedandfreestep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, codeValues, defaultValues) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var taxFreeCalcMethodSelect = stepContainer.js(jsSelectors.taxFreeCalcMethodSelect);
            var taxFreeAmountPercentContainer = stepContainer.js(jsSelectors.taxFreeAmountPercentContainer);
            var taxFreeAmountInput = stepContainer.js(jsSelectors.taxFreeAmountInput);
            var taxFreeAmountHidden = stepContainer.js(jsSelectors.taxFreeAmountHidden, { required: false });
            var taxFreePercentInput = stepContainer.js(jsSelectors.taxFreePercentInput);
            var taxFreePercentHidden = stepContainer.js(jsSelectors.taxFreePercentHidden, { required: false });

            // Hookup taxFreeCalcMethodSelect change event
            taxFreeCalcMethodSelect.change(enableDisableTaxFields);

            // Hookup taxFreeAmountInput and taxFreePercentInput change events
            taxFreeAmountInput.change(taxFreeAmountChange);
            taxFreePercentInput.change(taxFreePercentChange);

            // Enable or disable Tax Amount/Percent inputs based on selected Tax Free Calc Method
            function enableDisableTaxFields() {

                var selectedTaxFreeCalcMethod = taxFreeCalcMethodSelect.val();

                if (selectedTaxFreeCalcMethod == codeValues.simplified) {
                    taxFreeAmountPercentContainer.show();
                    taxFreeAmountInput.prop("disabled", true).val(defaultValues.simplifiedTaxFreeAmount);
                    taxFreeAmountHidden.val(defaultValues.simplifiedTaxFreeAmount);
                    taxFreePercentInput.prop("disabled", true).val("");
                    taxFreePercentHidden.val("");
                }
                else if (selectedTaxFreeCalcMethod == codeValues.userInput) {
                    taxFreeAmountPercentContainer.show();

                    if (defaultValues.userInputTaxFreeAmount != "") {
                        taxFreeAmountInput.prop("disabled", false).val(defaultValues.userInputTaxFreeAmount);
                        taxFreeAmountHidden.val(defaultValues.userInputTaxFreeAmount);
                        taxFreePercentInput.prop("disabled", true).val("");
                        taxFreePercentHidden.val("");
                    }
                    else if (defaultValues.userInputTaxFreePercent != "") {
                        taxFreeAmountInput.prop("disabled", false).val("");
                        taxFreeAmountHidden.val("");
                        taxFreePercentInput.prop("disabled", true).val(defaultValues.userInputTaxFreePercent);
                        taxFreePercentHidden.val(defaultValues.userInputTaxFreePercent);
                    }
                    else {
                        taxFreeAmountInput.prop("disabled", false).val("");
                        taxFreeAmountHidden.val("");
                        taxFreePercentInput.prop("disabled", false).val("");
                        taxFreePercentHidden.val("");
                    }
                }
                else {
                    taxFreeAmountPercentContainer.hide();
                    taxFreeAmountInput.val("");
                    taxFreeAmountHidden.val("");
                    taxFreePercentInput.val("");
                    taxFreePercentHidden.val("");
                }
            }

            // On Tax Free Percent change 
            function taxFreePercentChange() {

                // If a Percent is entered, disable and clear the Amount
                taxFreeAmountInput.prop('disabled', taxFreePercentHasValue());
                if (taxFreePercentHasValue()) {
                    taxFreeAmountInput.val("").clearErrors();
                    taxFreeAmountHidden.val("");
                }
            }

            // Return true if Tax Free Percent has a nonzero value
            function taxFreePercentHasValue() {
                return $.getNormalizedPercentValue(taxFreePercentInput.val()) != 0;
            }

            // On Tax Free Amount change  
            function taxFreeAmountChange() {

                // If an Amount is entered, disable and clear the Percent
                taxFreePercentInput.prop('disabled', taxFreeAmountHasValue());
                if (taxFreeAmountHasValue()) {
                    taxFreePercentInput.val("").clearErrors();
                    taxFreePercentHidden.val("");
                }
            }

            // Return true if Tax Free Amount has a nonzero value
            function taxFreeAmountHasValue() {
                return $.getNormalizedCurrencyValue(taxFreeAmountInput.val()) != 0;
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);